var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.children.length
        ? _c(
            "v-menu",
            {
              attrs: {
                "offset-x": "",
                "nudge-left": "6",
                "content-class": "workspace-sub-menu"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "button",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "settings-link",
                                attrs: { type: "button" }
                              },
                              "button",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _vm.normalizedIcon
                              ? _c(
                                  "span",
                                  { staticClass: "settings-icon" },
                                  [
                                    _c("portal-icon", {
                                      attrs: {
                                        size: 17,
                                        name: _vm.normalizedIcon
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("span", { staticClass: "settings-label" }, [
                              _vm._v(_vm._s(_vm.label))
                            ]),
                            _c("portal-icon", {
                              staticClass: "ml-auto",
                              attrs: { name: "chevron-right", size: 15 }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                4068798689
              )
            },
            [
              _c(
                "div",
                { staticClass: "settings-sub-menu" },
                _vm._l(_vm.children, function(child) {
                  return _c("settings-link", {
                    key: child.route || child.selectValue || child.label,
                    attrs: {
                      label: child.label,
                      route: child.route,
                      icon: child.icon,
                      "select-value": child.selectValue
                    },
                    on: {
                      selected: function($event) {
                        return _vm.$emit("selected", $event)
                      }
                    }
                  })
                }),
                1
              )
            ]
          )
        : _c(
            "button",
            {
              staticClass: "settings-link",
              class: { "is-selected": _vm.isSelected },
              attrs: { type: "button" },
              on: { click: _vm.handleClick }
            },
            [
              _vm.normalizedIcon
                ? _c(
                    "span",
                    { staticClass: "settings-icon" },
                    [
                      _c("portal-icon", {
                        attrs: { size: 17, name: _vm.normalizedIcon }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("span", { staticClass: "settings-label" }, [
                _vm._v(_vm._s(_vm.label))
              ]),
              _vm.isSelected
                ? _c("portal-icon", {
                    staticClass: "settings-check",
                    attrs: { name: "check", size: 16 }
                  })
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }